export const filterConstants = {
  clientVisionAttribute : "clientvision-com-cori",
  finalKPIAttribute : "final-kpi",
  initialKPIAttribute : "initial-kpi"
};
